export const scrollToBottom = () => {
  scrollTo({
    top: document.body.scrollHeight,
    behavior: "smooth",
  });
};
